import { render, staticRenderFns } from "./ModalAgreement.vue?vue&type=template&id=4b19fa92"
import script from "./ModalAgreement.vue?vue&type=script&lang=js"
export * from "./ModalAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports